/**
 * Card do plugin WhatsApp Cloud API no grid.
 */

import React from 'react';
import { IconBrandMeta, IconBolt } from '@tabler/icons-react';
import useCloudApiStatus from './useStatus';

const CloudApiCard = ({ agentId, context }) => {
  const status = useCloudApiStatus(agentId);

  const handleConnect = (e) => {
    e.stopPropagation();
    if (context?.onConnect) context.onConnect('whatsapp_cloud_api');
  };

  const handleConfigure = (e) => {
    e.stopPropagation();
    if (context?.onSelect) context.onSelect('whatsapp_cloud_api');
  };

  const cardClass = [
    'channel-card',
    status.isConnected && 'channel-card--connected',
    status.alertSeverity === 'warning' && 'channel-card--alert',
    status.alertSeverity === 'error' && 'channel-card--error',
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClass}>
      <div
        className="channel-card__icon"
        style={{ background: 'linear-gradient(135deg, #1877F2 0%, #0d5bc4 100%)', color: '#fff' }}
      >
        <IconBrandMeta size={22} />
      </div>

      <div className="channel-card__body">
        <h5 className="channel-card__name">
          WhatsApp Oficial
          {status.alertSeverity === 'error' && (
            <IconBolt size={14} style={{ color: '#dc2626' }} />
          )}
        </h5>
        <p className="channel-card__description">
          Conexão oficial via Meta Business Platform.
        </p>

        {status.isLoading && (
          <p className="channel-card__summary" style={{ color: '#9ca3af' }}>
            Carregando status...
          </p>
        )}

        {!status.isLoading && status.isConnected && (
          <p className="channel-card__summary">{status.summary}</p>
        )}

        {!status.isLoading && status.isConnected && (
          <div style={{ marginTop: 6, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {status.raw?.quality_rating && (
              <span className={`channel-card__status-pill channel-card__status-pill--${status.qualityVariant}`}>
                Qualidade: {status.raw.quality_rating}
              </span>
            )}
            {status.tierLabel && (
              <span className="channel-card__status-pill channel-card__status-pill--info">
                {status.tierLabel}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="channel-card__footer">
        {status.isConnected ? (
          <>
            <span className={`channel-card__status-pill channel-card__status-pill--${status.statusVariant}`}>
              {status.statusLabel}
            </span>
            <button
              type="button"
              className="channel-card__cta"
              onClick={handleConfigure}
              style={{ background: '#374151' }}
            >
              Gerenciar
            </button>
          </>
        ) : (
          <>
            <span />
            <button type="button" className="channel-card__cta" onClick={handleConnect}>
              Conectar
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CloudApiCard;
